import { useState } from "react"
import { FiFolder } from "react-icons/fi"

import { ASSET_DRAG_MIME, FOLDER_DRAG_MIME } from "./constants"

// A breadcrumb segment that is clickable to navigate, and accepts asset/folder
// drops (move-only) so users can move assets/folders into any ancestor while
// still browsing inside a child folder.
export default function BreadcrumbSegment({ isCurrent, onClick, onDrop, children }) {
    const [isDragOver, setIsDragOver] = useState(false)

    const handleDragOver = (e) => {
        const types = e.dataTransfer?.types
        if (!types) return
        const arr = Array.from(types)
        if (arr.includes(ASSET_DRAG_MIME) || arr.includes(FOLDER_DRAG_MIME)) {
            e.preventDefault()
            setIsDragOver(true)
            e.dataTransfer.dropEffect = 'move'
        }
    }

    const handleDragLeave = () => {
        setIsDragOver(false)
    }

    const handleDrop = (e) => {
        const assetData = e.dataTransfer.getData(ASSET_DRAG_MIME)
        const folderData = e.dataTransfer.getData(FOLDER_DRAG_MIME)
        if (!assetData && !folderData) return
        e.preventDefault()
        setIsDragOver(false)
        try {
            let assetIds = []
            let folderIds = []
            if (assetData) {
                const parsed = JSON.parse(assetData)
                assetIds = Array.isArray(parsed) ? parsed : []
            }
            if (folderData) {
                const parsed = JSON.parse(folderData)
                folderIds = Array.isArray(parsed) ? parsed : [parsed]
            }
            if (assetIds.length > 0 || folderIds.length > 0) onDrop?.({ assetIds, folderIds })
        } catch (err) {
            console.error('Bad drag payload', err)
        }
    }

    return (
        <span
            className={`inline-flex items-center gap-1 cursor-pointer truncate leading-none select-none p-0.5 rounded-xs ${isCurrent
                ? 'text-primary'
                : 'text-secondary-foreground hover:text-white'
            } ${isDragOver ? 'bg-primary !text-primary-foreground' : ''}`}
            onClick={onClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <FiFolder className='w-3 h-3 shrink-0' />
            <span className='truncate'>{children}</span>
        </span>
    )
}
